module.exports = __webpack_public_path__ + "img/coopera-icon.a0956c91.png";